import React from "react";
import { Button, Col } from "antd";
import { InputField, ReactSelectField } from "../../../../../atoms/FormElement";
import { InputNumberFieldV2 as InputNumberField } from "../../../../../atoms/FormElement/InputNumberField";
import { useSelector } from "react-redux";

var _ = require("lodash");

export default (props) => {
  const {
    control,
    errors,
    noEdit,
    colSpan,
    isUnitPopUp = false,
    isPropertyDetailsFetched = false,
  } = props;
  const configData = useSelector((state: any) => state.dashboard.configData);

  return (
    <>
      <Col span={colSpan ? colSpan : 6}>
        <InputField
          isRequired={!noEdit}
          label="Address Line 1"
          fieldname="addressLine1"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue=""
          iProps={{
            placeholder: "Enter Address Line 1",
            readOnly: noEdit || isPropertyDetailsFetched,
            className: `${noEdit ? "noEdit" : ""}`,
          }}
          rules={{ required: "Enter Address Line 1" }}
          validate={errors.addressLine1 && "error"}
          validMessage={errors.addressLine1 && errors.addressLine1.message}
          disabled={isPropertyDetailsFetched}
        />
      </Col>
      <Col span={colSpan ? colSpan : 6}>
        <InputField
          isRequired={
            !isUnitPopUp && (!props?.setSinglePropertyFlag ? false : false)
          }
          label="Address Line 2"
          fieldname="addressLine2"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue=""
          iProps={{
            placeholder: "Enter Address Line 2",
            readOnly: noEdit || isPropertyDetailsFetched,
            className: `${noEdit ? "noEdit" : ""}`,
          }}
          disabled={isPropertyDetailsFetched}
        />
      </Col>
      {isUnitPopUp && (
        <Col span={colSpan ? colSpan : 6}>
          <ReactSelectField
            isRequired={colSpan ? true : !noEdit}
            label="Emirate"
            fieldname="city"
            control={control}
            classes={`${noEdit ? "noEditLabel" : ""}`}
            initValue=""
            iProps={{
              placeholder: "Select City",
              isDisabled: noEdit || isPropertyDetailsFetched,
              className: `${noEdit ? "disablerselect" : ""}`,
            }}
            selectOption={_.map(
              [
                "Dubai",
                "Abu Dhabi",
                "Sharjah",
                "Ajman",
                "Umm Al Quwain",
                "Ras Al Khaimah",
                "Fujairah",
              ],
              (item) => ({
                value: item,
                label: item,
              })
            )}
            rules={{ required: "Select City" }}
            validate={errors.city && "error"}
            validMessage={errors.city && errors.city.message}
          />
        </Col>
      )}
      {!isUnitPopUp && (
        <Col span={colSpan ? colSpan : 6}>
          <ReactSelectField
            isRequired={!noEdit}
            label="Emirate"
            fieldname="emirates"
            control={control}
            classes={`${noEdit ? "noEditLabel" : ""}`}
            initValue=""
            iProps={{
              placeholder: "Select Emirate",
              isDisabled: noEdit,
              className: `${noEdit ? "disablerselect" : ""}`,
            }}
            selectOption={_.map(configData?.emiratesList, (item) => ({
              value: item,
              label: item,
            }))}
            rules={{ required: "Select Emirate" }}
            validate={errors.emirates && "error"}
            validMessage={errors.emirates && errors.emirates.message}
          />
        </Col>
      )}

      <Col span={colSpan ? colSpan : 6}>
        <ReactSelectField
          isRequired={colSpan ? true : !noEdit}
          label="Country"
          fieldname="country"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue=""
          iProps={{
            placeholder: "Select Country",
            isDisabled: noEdit || isPropertyDetailsFetched,
            className: `${noEdit ? "disablerselect" : ""}`,
          }}
          selectOption={_.map(["United Arab Emirates"], (item) => ({
            value: item,
            label: item,
          }))}
          rules={{ required: "Select Country" }}
          validate={errors.country && "error"}
          validMessage={errors.country && errors.country.message}
        />
      </Col>

      {!isUnitPopUp && (
        <Col span={colSpan ? colSpan : 6}>
          <ReactSelectField
            isRequired={colSpan ? true : !noEdit}
            label="Community"
            fieldname="community"
            control={control}
            classes={`${noEdit ? "noEditLabel" : ""}`}
            initValue=""
            iProps={{
              placeholder: "Select Community",
              isDisabled: noEdit,
              className: `${noEdit ? "disablerselect" : ""}`,
            }}
            selectOption={_.map(
              configData?.locationlist?.sublocation,
              (item, key) => ({
                value: item,
                label: item,
              })
            )}
            rules={{ required: "Please select" }}
            validate={errors.community && "error"}
            validMessage={errors.community && errors.community.message}
          />
        </Col>
      )}

      <Col span={colSpan ? colSpan : 6}>
        <InputNumberField
          isRequired={colSpan ? true : !noEdit}
          label="Latitude"
          fieldname="latitude"
          control={control}
          inputNumberProps={{
            placeholder: "25.0554",
            readOnly: noEdit || isPropertyDetailsFetched,
            className: noEdit ? "noEdit" : "",
            precision: 10,
          }}
          rules={{ required: "Enter Latitude" }}
          disabled={isPropertyDetailsFetched}
        />
      </Col>
      <Col span={colSpan ? colSpan : 6}>
        <InputNumberField
          isRequired={colSpan ? true : !noEdit}
          label="Longitude"
          fieldname="longitude"
          control={control}
          inputNumberProps={{
            placeholder: "55.1522",
            readOnly: noEdit || isPropertyDetailsFetched,
            className: noEdit ? "noEdit" : "",
            precision: 10,
          }}
          rules={{ required: "Enter Longitude" }}
          disabled={isPropertyDetailsFetched}
        />
      </Col>

      {/* adding these fields after story 9873 in sprint 41 and 42 */}

      {!isUnitPopUp && (
        <Col span={colSpan ? colSpan : 6}>
          <InputField
            isRequired={colSpan ? false : false}
            label="Makani No"
            fieldname="makaniNumber"
            control={control}
            classes={`${noEdit ? "noEditLabel" : ""}`}
            initValue=""
            iProps={{
              placeholder: "Makani No",
              readOnly: noEdit,
              className: `${noEdit ? "noEdit" : ""}`,
            }}
          />
        </Col>
      )}

      {!isUnitPopUp && (
        <Col span={colSpan ? colSpan : 6}>
          <InputField
            isRequired={colSpan ? false : false}
            label="Alternate Property Name"
            fieldname="alternatePropertyName"
            control={control}
            classes={`${noEdit ? "noEditLabel" : ""}`}
            initValue=""
            iProps={{
              placeholder: "Alternate Property Name",
              readOnly: noEdit,
              className: `${noEdit ? "noEdit" : ""}`,
            }}
          />
        </Col>
      )}

      {!isUnitPopUp && (
        <Col span={colSpan ? colSpan : 6}>
          <InputField
            isRequired={colSpan ? false : false}
            label="Land No"
            fieldname="landNnumber"
            control={control}
            classes={`${noEdit ? "noEditLabel" : ""}`}
            initValue=""
            iProps={{
              placeholder: "Land No",
              readOnly: noEdit,
              className: `${noEdit ? "noEdit" : ""}`,
            }}
          />
        </Col>
      )}
      {!isUnitPopUp && (
        <Col span={colSpan ? colSpan : 6}>
          <InputField
            isRequired={
              isUnitPopUp || props?.setSinglePropertyFlag ? true : false
            }
            label="DM. No."
            fieldname="DMNumber"
            control={control}
            classes={`${noEdit ? "noEditLabel" : ""}`}
            initValue=""
            iProps={{
              placeholder: "DM. No.",
              readOnly: noEdit || isPropertyDetailsFetched,
              className: `${noEdit ? "noEdit" : ""}`,
            }}
            rules={{ required: "Please enter dewa premise number" }}
            validate={errors.DMNumber && "error"}
            validMessage={errors.DMNumber && errors.DMNumber.message}
            disabled={isPropertyDetailsFetched}
          />
        </Col>
      )}

      {props?.setSinglePropertyFlag && (
        <Col span={8}>
          <InputField
            isRequired={true}
            label="Owner Number"
            fieldname="ownerNumber"
            control={control}
            //   classes={`${noEdit ? "noEditLabel" : ""}`}
            initValue=""
            iProps={{
              placeholder: "Owner Number",
              // readOnly: noEdit,
              // className: `${noEdit ? "noEdit" : ""}`,
            }}
            rules={{ required: "Owner Number Is Required" }}
            validate={errors.ownerNumber && "error"}
            validMessage={errors.ownerNumber && errors.ownerNumber.message}
          />
        </Col>
      )}

      {colSpan && !isUnitPopUp && (
        <Col span={24}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "30px",
            }}
          >
            <Button
              onClick={() => props?.setSinglePropertyFlag(false)}
              htmlType="submit"
              type="default"
              size="large"
              className="csv_publish"
            >
              Back
            </Button>
            <Button
              htmlType="submit"
              type="primary"
              size="large"
              className="csv_publish"
            >
              Submit
            </Button>
          </div>
        </Col>
      )}
    </>
  );
};
